<template>
    <div class="float-left">
        <span class="text-success float-left mr-1">
            <i
                class="fa fa-money fa-lg icon-button"
                title="Liberar Recurso"
                @click="abrirModal()"
                v-if="$temAcessoView('CONV-00')"
            ></i>
        </span>
        <b-modal
            id="modalAdicionarRecurso"
            size="lg"
            v-model="mostrarModal"
            no-close-on-backdrop
        >
            <div slot="modal-title">
                Liberação de Recursos -
                <b-badge variant="warning">NOVO</b-badge>
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12" md="12">
                    <b-form-group>
                        <label for="vcDescricao">Descrição</label>
                        <b-input-group>
                            <b-form-input
                                id="vcDescricao"
                                type="text"
                                v-model="cronogramasDesembolsos.vcDescricao"
                                :disabled="true"
                            >
                            </b-form-input>
                            <b-form-invalid-feedback>Descrição é obrigatória</b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label for="nuParcela">Parcela</label>
                        <b-input-group>
                            <b-form-input
                                id="nuParcela"
                                type="number"
                                min="0"
                                max="999999"
                                step="1"
                                v-model="cronogramasDesembolsos.nuParcela"
                                :disabled="true"
                            ></b-form-input>
                            <b-form-invalid-feedback>Parcela é obrigatória</b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label for="dtLiberacao">Data Liberação</label>
                        <b-input-group>
                            <date-picker
                                id="dtLiberacao"
                                v-model="cronogramasDesembolsos.dtLiberacao"
                                :config="$datePickerOptions"
                                v-mask="'##/##/####'"
                                @input.native="$v.mesPrevisto.$touch()"
                            ></date-picker>
                            <b-form-invalid-feedback>Mês\Ano é obrigatório</b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label for="vlLiberado">Valor</label>
                        <b-input-group>
                            <money
                                id="vlLiberado"
                                v-model="cronogramasDesembolsos.vlLiberado"
                                v-bind="money"
                                class="form-control text-right"
                                @input.native="$v.valor.$touch()"
                                :disabled="true"
                            ></money>
                            <b-form-invalid-feedback>Valor é obrigatória</b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>
                </b-col>

            </b-row>

            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharModal()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="desativarBotao"
                    @click.stop="salvarDesembolso()"
                    class="ml-1"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import ConveniosServicos from '../ConveniosServicos'
import { required, minValue } from 'vuelidate/lib/validators'

export default {
    props: {
        parentData: Object,
        desativarBotao: Boolean
    },

    validations: {
        valor: {
            required,
            minValue: minValue(0.01)
        }
    },

    data(){
        return {
            mostrarModal: false,
            erros: [],
            naturezas: [],
            valor: 0,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            cronogramasDesembolsos: {
                codSituacao: null,
                dtLiberacao: null,
                dtMesAno: null,
                idConvenio: 0,
                idCronogramaDesembolso: 0,
                nuParcela: 0,
                nuValorDesembolso: 0,
                percExecucao: null,
                vcDescricao: null,
                vlLiberado: null,
            },
        }
    },

    methods: {
        abrirModal() {
            if (!this.desativarBotao) {
                this.mostrarModal = true;

                this.cronogramasDesembolsos.codSituacao = this.parentData.codSituacao;
                this.cronogramasDesembolsos.dtLiberacao = null;
                this.cronogramasDesembolsos.dtMesAno = this.parentData.dtMesAno;
                this.cronogramasDesembolsos.idConvenio = this.parentData.idConvenio;
                this.cronogramasDesembolsos.idCronogramaDesembolso = this.parentData.idCronogramaDesembolso;
                this.cronogramasDesembolsos.nuParcela = this.parentData.nuParcela;
                this.cronogramasDesembolsos.nuValorDesembolso = this.parentData.nuValorDesembolso;
                this.cronogramasDesembolsos.percExecucao = 100;
                this.cronogramasDesembolsos.vcDescricao = this.parentData.vcDescricao;
                this.cronogramasDesembolsos.vlLiberado = this.parentData.nuValorDesembolso;
            }
        },

        fecharModal() {
            this.mostrarModal = false
        },

        salvarDesembolso(){
            this.cronogramasDesembolsos.dtLiberacao = this.$moment(this.cronogramasDesembolsos.dtLiberacao, 'DD/MM/YYYY').format('YYYY-MM-DD')

            ConveniosServicos.AlterarCronogramaDesembolso(this.cronogramasDesembolsos)
            .then(response => {
                if (response) {
                    if (response.success) {
                        this.cronogramasDesembolsos = response.data
                        this.$emit('atualizarLista')
                        this.fecharModal()
                    }
                    else{
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },
}

</script>

